import {trackLogout} from '@aboutyou/legacy-tracking-sdk';
import type {AuthMedium} from '@aboutyou/user';
import {useTracking} from '../utils/utils';

export const useTrackLogout = () => {
  const {TrackingClient, pageContextCallback, scheduleCustomerDataEvent} =
    useTracking();
  return ({
    action,
    label,
  }: {
    action: 'successful' | 'error';
    label?: AuthMedium;
  }) => {
    scheduleCustomerDataEvent();
    TrackingClient.track(
      trackLogout({
        action,
        label,
        page: pageContextCallback(),
      }),
    );
  };
};
